import storageAPI from '@/services/api/institute/storage'

const Storage = {
	namespaced: true,
	state: () => ({
		storageTree: undefined,
		selectedStorage: undefined,
		warningList: undefined,
		storageTreeAll: undefined,
		singleSelectedStorage: undefined,
	}),
	getters: {
		getStorageNodeCount(state) {
			let count = 0
			function curcuitTree(tree) {
				if (tree) {
					for (let idx = 0; idx < tree.length; idx++) {
						curcuitTree(tree[idx].children)
						count++
					}
				}
			}
			curcuitTree(state.storageTreeAll)

			return count
		},
		getStorageNodeIdList(state) {
			let idList = []
			function curcuitTree(tree) {
				if (tree) {
					for (let idx = 0; idx < tree.length; idx++) {
						curcuitTree(tree[idx].children)
						idList.push(tree[idx].id)
					}
				}
			}
			curcuitTree(state.storageTreeAll)

			return idList
		},
	},
	mutations: {
		setStorageTree(state, payload) {
			state.storageTree = payload
		},
		setSelectedStorage(state, payload) {
			state.selectedStorage = payload
		},
		setWarningList(state, payload) {
			state.warningList = payload
		},
		setStorageTreeAll(state, payload) {
			state.storageTreeAll = payload
		},
		setSingleSelectedStorage(state, payload) {
			state.singleSelectedStorage = payload
		},
	},
	actions: {
		loadStorageTreeAll: async ({ commit, dispatch }, payload) => {
			const { instituteId } = payload
			const response = await storageAPI.lookupStorageTreeAll(instituteId)
			commit('setStorageTreeAll', response.data)
		},
		loadStorageTree: async ({ commit, dispatch }, payload) => {
			const { institutionId, storageId } = payload
			const response = await storageAPI.lookupStorageTree(
				institutionId,
				storageId
			)
			commit('setStorageTree', response.data)
			const detailPayload = {
				institutionId: institutionId,
				storageId: response.data.id,
			}
			await dispatch('loadStorageDetail', detailPayload)
		},
		loadStorageDetail: async ({ commit }, payload) => {
			const { institutionId, storageId } = payload
			const response = await storageAPI.lookupStorageTree(
				institutionId,
				storageId
			)
			commit('setSelectedStorage', response.data)
		},
		loadWarningList: async ({ commit }) => {
			const response = await storageAPI.lookupWarningList()
			commit('setWarningList', response.data)
		},
	},
}
export default Storage
